import { useCallback, useEffect, useState } from 'react';
import './Foto.css';

interface Album {
    title: string;
    photos: string[];
}

const albums: Album[] = [
    {
        title: 'Eventi e incontri',
        photos: [
            process.env.PUBLIC_URL + '/foto/eventi-e-incontri/o-pexels-rahimegul-28637073.jpg',
            process.env.PUBLIC_URL + '/foto/eventi-e-incontri/q-pexels-jose-gutierrez-391113587-25753499.jpg',
            process.env.PUBLIC_URL + '/foto/eventi-e-incontri/q-pexels-jos-van-ouwerkerk-377363-27818626.jpg',
            process.env.PUBLIC_URL + '/foto/eventi-e-incontri/q-pexels-klaus-machtel-2147699903-29726952.jpg',
            process.env.PUBLIC_URL + '/foto/eventi-e-incontri/v-pexels-nadiye-odabasi-3668408-19455153.jpg',
        ],
    },
    {
        title: 'Dirette con Radio Cosmo',
        photos: [
            process.env.PUBLIC_URL + '/foto/dirette-radio-cosmo/o-pexels-ftmglgkhn-37689845.jpg',
            process.env.PUBLIC_URL + '/foto/dirette-radio-cosmo/o-pexels-lineartwork-13534914.jpg',
            process.env.PUBLIC_URL + '/foto/dirette-radio-cosmo/q-pexels-batitay-japheth-43379766-16333667.jpg',
            process.env.PUBLIC_URL + '/foto/dirette-radio-cosmo/q-pexels-emhopper-20249478.jpg',
            process.env.PUBLIC_URL + '/foto/dirette-radio-cosmo/v-pexels-aydin-photography-298758980-33269594.jpg',
            process.env.PUBLIC_URL + '/foto/dirette-radio-cosmo/v-pexels-msaimakin-37430931.jpg',
        ],
    },
];

function Foto() {
    const [selectedAlbum, setSelectedAlbum] = useState<number | null>(null);
    const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

    const album = selectedAlbum !== null ? albums[selectedAlbum] : null;

    const closeLightbox = useCallback(() => setLightboxIndex(null), []);

    const showPrev = useCallback(() => {
        setLightboxIndex((i) => (i !== null && i > 0 ? i - 1 : i));
    }, []);

    const showNext = useCallback(() => {
        setLightboxIndex((i) => (album && i !== null && i < album.photos.length - 1 ? i + 1 : i));
    }, [album]);

    const backToAlbums = () => {
        setLightboxIndex(null);
        setSelectedAlbum(null);
    };

    useEffect(() => {
        if (lightboxIndex === null) return;

        document.body.style.overflow = 'hidden';

        function handleKeyDown(e: KeyboardEvent) {
            if (e.key === 'Escape') closeLightbox();
            else if (e.key === 'ArrowLeft') showPrev();
            else if (e.key === 'ArrowRight') showNext();
        }

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.body.style.overflow = '';
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [lightboxIndex, closeLightbox, showPrev, showNext]);

    return (
        <div className='foto-container'>
            <h1 className='foto-title'>Foto</h1>

            {!album ? (
                <>
                    <p>
                        Alcuni momenti delle attività e degli eventi dell'Associazione Settemotivi: incontri,
                        dirette radiofoniche con Radio Cosmo e iniziative sul territorio.
                    </p>

                    <div className='foto-album-grid'>
                        {albums.map((a, i) => (
                            <button
                                key={a.title}
                                type='button'
                                className='foto-album-card'
                                onClick={() => setSelectedAlbum(i)}
                            >
                                <img src={a.photos[0]} alt='' />
                                <span className='foto-album-title'>{a.title}</span>
                            </button>
                        ))}
                    </div>
                </>
            ) : (
                <>
                    <button type='button' className='foto-back-link' onClick={backToAlbums}>
                        <span className='foto-back-arrow' aria-hidden='true'>&#8592;</span>
                        <span>Torna agli album</span>
                    </button>

                    <h2 className='foto-album-heading'>{album.title}</h2>

                    <div className='foto-grid'>
                        {album.photos.map((src, i) => (
                            <button
                                key={src}
                                type='button'
                                className='foto-photo-button'
                                onClick={() => setLightboxIndex(i)}
                            >
                                <img src={src} alt='' />
                            </button>
                        ))}
                    </div>
                </>
            )}

            {album && lightboxIndex !== null && (
                <div className='foto-lightbox-overlay' onClick={closeLightbox}>
                    <button
                        type='button'
                        className='foto-lightbox-close'
                        aria-label='Chiudi'
                        onClick={closeLightbox}
                    >
                        &#10005;
                    </button>

                    <button
                        type='button'
                        className='foto-lightbox-arrow foto-lightbox-prev'
                        aria-label='Foto precedente'
                        disabled={lightboxIndex === 0}
                        onClick={(e) => {
                            e.stopPropagation();
                            showPrev();
                        }}
                    >
                        &#8592;
                    </button>

                    <img
                        src={album.photos[lightboxIndex]}
                        alt=''
                        className='foto-lightbox-image'
                        onClick={(e) => e.stopPropagation()}
                    />

                    <button
                        type='button'
                        className='foto-lightbox-arrow foto-lightbox-next'
                        aria-label='Foto successiva'
                        disabled={lightboxIndex === album.photos.length - 1}
                        onClick={(e) => {
                            e.stopPropagation();
                            showNext();
                        }}
                    >
                        &#8594;
                    </button>
                </div>
            )}
        </div>
    );
}

export default Foto;
